/**
 * Kept in its own file so `Root` can read it without pulling the investor
 * chunk into the main bundle. Written by the investor shell, read by `Root`
 * to show a signed-out investor the data-room page rather than Microsoft
 * sign-in. A convenience only: it grants nothing, and an empty value means the
 * staff sign-in, which is what it meant before the data room existed.
 */
export const INVESTOR_SURFACE_KEY = 'excellence:surface'
